import colors from '../colors';
import { buildGet } from '../../utils/typography/get';
import { buildTypes } from '../../utils/typography/types';
export const family = {
  opensans: '"Open Sans", sans-serif, Tahoma, Arial',
  montserrat: '"Montserrat", sans-serif'
};
export const weight = {
  extraBold: '800',
  bold: '700',
  semiBold: '600',
  medium: '500',
  light: '400',
  regular: '400'
};
export const lineHeightDefaults = {
  '3XL': 'line-height: 72px;',
  '2XL': 'line-height: 64px;',
  XL: 'line-height: 48px;',
  large: 'line-height: 40px;',
  MExtra: 'line-height: 28px;',
  MSemi: 'line-height: 28px;',
  SExtra: 'line-height: 24px;',
  SSemi: 'line-height: 24px;',
  XSExtra: 'line-height: 16px;',
  XSSemi: 'line-height: 16px;',
  XSMedium: 'line-height: 16px;',
  XXS: 'line-height: 12px;',
  bodyXL: 'line-height: 26px;',
  bodyL: 'line-height: 26px;',
  body: 'line-height: 24px;',
  bodyWide: 'line-height: 36px;',
  bodyTight: 'line-height: 18px;',
  bodySmall: 'line-height: 12px;',
  body12: 'line-height: 18px',
  SpecialXSExtra: 'line-height: 16px;',
  SpecialXSSemi: 'line-height: 16px;',
  SpecialXSMedium: 'line-height: 16px;',
  Breadcrumb: 'line-height: 21px;'
};
export const fontColorDefaults = {
  '3XL': "color: ".concat(colors.primary.black, ";"),
  '2XL': "color: ".concat(colors.primary.black, ";"),
  XL: "color: ".concat(colors.primary.black, ";"),
  large: "color: ".concat(colors.primary.black, ";"),
  MExtra: "color: ".concat(colors.primary.black, ";"),
  MSemi: "color: ".concat(colors.primary.black, ";"),
  SExtra: "color: ".concat(colors.primary.black, ";"),
  SSemi: "color: ".concat(colors.primary.black, ";"),
  XSExtra: "color: ".concat(colors.primary.black, ";"),
  XSSemi: "color: ".concat(colors.primary.black, ";"),
  XSMedium: "color: ".concat(colors.primary.black, ";"),
  XXS: "color: ".concat(colors.primary.black, ";"),
  bodyXL: "color: ".concat(colors.neutral.charcoal, ";"),
  bodyL: "color: ".concat(colors.neutral.charcoal, ";"),
  body: "color: ".concat(colors.neutral.charcoal, ";"),
  bodyWide: "color: ".concat(colors.neutral.charcoal, ";"),
  bodyTight: "color: ".concat(colors.neutral.charcoal, ";"),
  body12: "color: ".concat(colors.neutral.charcoal, ";"),
  bodySmall: "color: ".concat(colors.neutral.charcoal, ";"),
  SpecialXSExtra: "color: ".concat(colors.primary.black, ";"),
  SpecialXSSemi: "color: ".concat(colors.primary.black, ";"),
  SpecialXSMedium: "color: ".concat(colors.primary.black, ";"),
  Breadcrumb: "color: ".concat(colors.action.darkBrightBlue, ";")
};
export const defaults = {
  '3XL': "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 72px;\n    font-weight: ").concat(weight.extraBold, ";\n    letter-spacing: 0;\n    text-transform: capitalize;\n  "),
  '2XL': "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 60px;\n    font-weight: ").concat(weight.extraBold, ";\n    letter-spacing: 0;\n    text-transform: capitalize;\n  "),
  XL: "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 46px;\n    font-weight: ").concat(weight.extraBold, ";\n    letter-spacing: 0;\n  "),
  large: "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 36px;\n    font-weight: ").concat(weight.extraBold, ";\n    letter-spacing: 0;\n    text-transform: capitalize;\n  "),
  MExtra: "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 24px;\n    font-weight: ").concat(weight.extraBold, ";\n    letter-spacing: 0;\n    text-transform: capitalize;\n  "),
  MSemi: "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 24px;\n    font-weight: ").concat(weight.semiBold, ";\n    letter-spacing: 0;\n    text-transform: capitalize;\n  "),
  SExtra: "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 18px;\n    font-weight: ").concat(weight.extraBold, ";\n    letter-spacing: 0;\n    text-transform: capitalize;\n  "),
  SSemi: "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 18px;\n    font-weight: ").concat(weight.semiBold, ";\n    letter-spacing: 0;\n    text-transform: capitalize;\n  "),
  XSExtra: "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 14px;\n    font-weight: ").concat(weight.extraBold, ";\n    letter-spacing: 0.5px;\n  "),
  XSSemi: "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 14px;\n    font-weight: ").concat(weight.semiBold, ";\n    letter-spacing: 0.5px;\n  "),
  XSMedium: "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 14px;\n    font-weight: ").concat(weight.medium, ";\n    letter-spacing: 0.5px;\n  "),
  XXS: "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 10px;\n    font-weight: ").concat(weight.semiBold, ";\n    letter-spacing: 0;\n  "),
  bodyXL: "\n    font-family: ".concat(family.opensans, ";\n    font-size: 18px;\n    font-weight: ").concat(weight.semiBold, ";\n    letter-spacing: 0;\n  "),
  bodyL: "\n    font-family: ".concat(family.opensans, ";\n    font-size: 16px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n  "),
  body: "\n    font-family: ".concat(family.opensans, ";\n    font-size: 14px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n  "),
  bodyWide: "\n    font-family: ".concat(family.opensans, ";\n    font-size: 14px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n  "),
  bodyTight: "\n    font-family: ".concat(family.opensans, ";\n    font-size: 14px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n  "),
  body12: "\n    font-family: ".concat(family.opensans, ";\n    font-size: 12px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0;\n  "),
  bodySmall: "\n    font-family: ".concat(family.opensans, ";\n    font-size: 10px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0.7px;\n  "),
  SpecialXSExtra: "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 12px;\n    font-weight: ").concat(weight.extraBold, ";\n    letter-spacing: 0.5px;\n  "),
  SpecialXSSemi: "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 12px;\n    font-weight: ").concat(weight.semiBold, ";\n    letter-spacing: 0.5px;\n  "),
  SpecialXSMedium: "\n    font-family: ".concat(family.montserrat, ";\n    font-size: 12px;\n    font-weight: ").concat(weight.medium, ";\n    letter-spacing: 0.5px;\n  "),
  Breadcrumb: "\n    font-family: ".concat(family.opensans, ";\n    font-size: 12px;\n    font-weight: ").concat(weight.regular, ";\n    letter-spacing: 0.5px;\n  ")
};
export const types = buildTypes({
  defaults,
  fontColorDefaults,
  lineHeightDefaults
});
export const get = buildGet({
  defaults,
  fontColorDefaults,
  lineHeightDefaults
});
//# sourceMappingURL=typography.js.map